import { sb } from '../../supabase.ts';

export async function renderOtherSchoolDownloadFormPage(app: HTMLElement): Promise<void> {
  const TABLE = 'student_database_others';

  app.innerHTML = `
    <style>
      .df-wrap {
        font-family: 'Outfit', 'Segoe UI', sans-serif;
        background: radial-gradient(circle at 50% 50%, rgba(16, 185, 129, 0.05), transparent 45%), linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
        min-height: 100vh;
        color: #334155;
        padding: 24px;
        box-sizing: border-box;
      }
      .df-header {
        max-width: 800px;
        margin: 0 auto 24px;
        text-align: center;
      }
      .df-header h1 {
        font-size: 24px;
        color: #0f172a;
        margin: 0;
      }
      .search-box {
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.05);
        border-radius: 12px;
        padding: 24px;
        max-width: 600px;
        margin: 0 auto 24px;
        display: flex;
        gap: 12px;
        flex-direction: column;
      }
      .search-box label {
        font-size: 14px;
        font-weight: 600;
        color: #64748b;
      }
      .search-box input {
        padding: 12px 16px;
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 8px;
        color: #0f172a;
        font-size: 16px;
        outline: none;
      }
      .search-box button {
        padding: 12px;
        background: #10b981;
        border: none;
        border-radius: 8px;
        color: #fff; font-weight: 700; cursor: pointer;
        transition: opacity 0.2s;
      }
      .search-box button:hover { opacity: 0.9; }
      
      .status {
        text-align: center;
        padding: 12px;
        margin-top: 12px;
      }
      .status.err { color: #ef4444; }
      .status.ok { color: #10b981; }

      .receipt {
        display: none;
        background: #ffffff;
        border-radius: 8px;
        padding: 32px;
        max-width: 700px;
        margin: 0 auto;
        color: #000;
        box-shadow: 0 4px 20px rgba(0,0,0,0.1);
      }
      .receipt-header {
        text-align: center;
        border-bottom: 2px solid #000;
        padding-bottom: 16px;
        margin-bottom: 24px;
      }
      .receipt-header h2 { margin: 0; font-size: 20px; text-transform: uppercase; }
      .receipt-row {
        display: flex;
        justify-content: space-between;
        margin-bottom: 8px;
        border-bottom: 1px dashed #ccc;
        padding-bottom: 4px;
      }
      .actions {
        display: flex;
        justify-content: center;
        margin-top: 24px;
      }
      .actions button {
        padding: 12px 24px;
        background: linear-gradient(135deg, #10b981, #059669);
        border: none;
        border-radius: 8px;
        color: #ffffff; font-weight: 700; cursor: pointer;
        box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2);
      }
      @media print {
        .df-header, .search-box, .actions { display: none !important; }
        body { background: #fff; }
        .receipt { box-shadow: none; border: none; }
      }
    </style>

    <div class="df-wrap">
      <div class="df-header">
        <a href="/other_school_dashboard" style="color:#10b981;text-decoration:none;display:block;margin-bottom:12px;">⬅ Back to Dashboard</a>
        <h1>Download Admission Receipt</h1>
        <p style="color:#8b949e">Print your application form copy.</p>
      </div>

      <div class="search-box">
        <label>Enter Birth Registration Number</label>
        <input type="text" id="searchBrc" placeholder="17-digit birth registration number..." />
        <button id="searchBtn">Find Receipt</button>
        <div id="searchStatus" class="status"></div>
      </div>

      <div id="receiptBox" class="receipt">
        <div class="receipt-header">
          <h2>Feni Model High School</h2>
          <p style="margin:4px 0 0">Admission Application Receipt (Other School)</p>
        </div>
        
        <div class="receipt-row">
          <strong>Student ID (IID):</strong>
          <span id="rIid"></span>
        </div>
        <div class="receipt-row">
          <strong>Name:</strong>
          <span id="rName"></span>
        </div>
        <div class="receipt-row">
          <strong>Father's Name:</strong>
          <span id="rFather"></span>
        </div>
        <div class="receipt-row">
          <strong>Class:</strong>
          <span id="rClass"></span>
        </div>
        <div class="receipt-row">
          <strong>Admission Date:</strong>
          <span id="rDate"></span>
        </div>
        <div class="receipt-row">
          <strong>Status:</strong>
          <span id="rStatus"></span>
        </div>

        <div class="actions">
          <button id="printBtn">🖨️ Print Receipt</button>
        </div>
      </div>
    </div>
  `;

  const searchBtn = document.getElementById('searchBtn') as HTMLButtonElement;
  const searchBrc = document.getElementById('searchBrc') as HTMLInputElement;
  const searchStatus = document.getElementById('searchStatus') as HTMLDivElement;
  
  const receiptBox = document.getElementById('receiptBox') as HTMLDivElement;
  const printBtn = document.getElementById('printBtn') as HTMLButtonElement;
  
  searchBtn.onclick = async () => {
    const brc = searchBrc.value.trim();
    if (!brc) {
      searchStatus.className = 'status err';
      searchStatus.textContent = 'Please enter a birth registration number';
      return;
    }

    searchStatus.className = 'status';
    searchStatus.textContent = 'Searching...';
    searchBtn.disabled = true;

    try {
      const { data, error } = await sb.from(TABLE).select('*').eq('birth_registration', brc).limit(1);
      if (error) throw error;
      
      if (!data || data.length === 0) {
        searchStatus.className = 'status err';
        searchStatus.textContent = 'No application found.';
        receiptBox.style.display = 'none';
      } else {
        const student = data[0];
        searchStatus.className = 'status ok';
        searchStatus.textContent = 'Found!';
        
        document.getElementById('rIid')!.textContent = student.iid || '-';
        document.getElementById('rName')!.textContent = student.student_name_en || '-';
        document.getElementById('rFather')!.textContent = student.father_name_en || '-';
        document.getElementById('rClass')!.textContent = student.class_2026 || '-';
        document.getElementById('rDate')!.textContent = student.admission_date || '-';
        
        const isApproved = ['1', 'yes', 'true', 't'].includes(String(student.admission_status || '').toLowerCase());
        document.getElementById('rStatus')!.textContent = isApproved ? 'APPROVED' : 'PENDING';
        
        receiptBox.style.display = 'block';
      }
    } catch (err: any) {
      searchStatus.className = 'status err';
      searchStatus.textContent = 'Error: ' + err.message;
    } finally {
      searchBtn.disabled = false;
    }
  };

  printBtn.onclick = () => window.print();
}
